import { FetchResult } from 'apollo-link';
import { DataProxy } from 'apollo-cache';
import produce from 'immer';

import {
  GetLeaderboardConfigScoresDocument,
  LeaderboardConfig,
  ModifyLeaderboardScoresMutation,
} from 'api';

type UpdateLeaderboardScores = [
  DataProxy,
  FetchResult<ModifyLeaderboardScoresMutation>,
  LeaderboardConfig['id'],
];

export default (...args: UpdateLeaderboardScores) => {
  const [cache, mutationResult, id] = args;

  const { modifyLeaderboardConfigScores } = mutationResult.data;
  const { getLeaderboardConfigScores } = cache.readQuery({
    query: GetLeaderboardConfigScoresDocument,
    variables: { id },
  });

  const nextLeaderboardScores = produce(getLeaderboardConfigScores, (draft: any) => {
    draft = modifyLeaderboardConfigScores;
    return draft;
  });

  cache.writeQuery({
    query: GetLeaderboardConfigScoresDocument,
    variables: { id },
    data: { getLeaderboardConfigScores: nextLeaderboardScores },
  });
};
